<template>
  <div class="inv-add-inner-box">
    <img src="@/assets/img/hbeij_title.png" alt="" width="100%">
    <div class="inv-add-content-box">
      <p class="inv-add-content-title">发票录入</p>
      <ul class="inv-add-content-from">
        <li>
          <p>发票代码：</p>
          <input
            type="number"
            placeholder="请输入10/12位发票代码"
            v-model="parmars.billCode"
          />
          <img @click="openScan" src="@/assets/img/sao.png" alt="" />
        </li>
        <li>
          <p>发票号码：</p>
          <input
            type="number"
            placeholder="请输入8位发票号码"
            v-model="parmars.billNumber"
          />
        </li>
        <li>
          <p>开票日期：</p>
          <input
            type="date"
            placeholder="请选择开票日期"
            v-model="parmars.billTime"
          />
        </li>
        <li>
          <p>开票金额：</p>
          <input
            type="number"
            :placeholder="`请输入发票金额，不低于${config.minMoney}`"
            v-model="parmars.billMoney"
            @change="billMoneyChange"
          />
        </li>
        <li>
          <p>姓名：</p>
          <input
            type="text"
            placeholder="请输入姓名"
            v-model="parmars.billName"
          />
        </li>
        <li>
          <p>手机号码：</p>
          <input
            type="number"
            placeholder="请输入11位手机号码"
            v-model="parmars.billPhone"
          />
        </li>
        <li>
          <p>身份证号<br />后8位：</p>
          <input
            type="text"
            placeholder="请输入身份证后8位"
            v-model="parmars.billCard"
          />
        </li>
        <!-- <li>
          <p>验证码：</p>
          <div class="code-box">
            <input
              type="text"
              style="width: calc(100% - 110px)"
              v-model="inpCode"
            />
            <s-identify
              ref="identify"
              v-model="identifyCode"
              :contentWidth="100"
              :contentHeight="36"
            ></s-identify>
          </div>
        </li> -->
        <div class="inv-add-content-btn" @click="save">提交</div>
        <router-link to="/invoiceSelect" class="select-inv"
          >中奖查询</router-link
        >
      </ul>
    </div>
  </div>
</template>

<script>
import * as sctipts from "../service/invoice";
import SIdentify from "@/components/identify";
export default {
  data() {
    return {
      identifyCode: "",
      parmars: {
        billCard: "",
        billCode: "",
        billMoney: "",
        billName: "",
        billNumber: "",
        billPhone: "",
        billTime: "",
      },
      // inpCode: "",
      config: {},
    };
  },
  mounted() {
    this.getRem(750, 100);
    window.onresize = () => {
      this.getRem(750, 100);
    };
    document.title = "发票录入";
    sctipts.getConfig().then(({ data }) => {
      if (data.status == 0) {
        this.config = data.data;
      }
    });
  },
  components: {
    SIdentify,
  },
  methods: {
    getRem(pwidth, prem) {
      let html = document.getElementsByTagName("html")[0];
      let oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / pwidth) * prem + "px";
    },
    checkPhone(value) {
      if (/^1[3456789]\d{9}$/.test(value)) {
        return true;
      } else {
        return false;
      }
    },
    save() {
      if (this.parmars.billName == "") {
        alert("请输入姓名");
      } else if (this.parmars.billCode == "") {
        alert("请输入发票代码");
      } else if (
        this.parmars.billCode.length > 12 ||
        this.parmars.billCode.length < 10
      ) {
        alert("请输入10/12位发票代码");
      } else if (this.parmars.billNumber == "") {
        alert("请输入发票号码");
      } else if (this.parmars.billNumber.length != 8) {
        alert("请输入8位发票号码");
      } else if (this.parmars.billTime == "") {
        alert("请选择开票日期");
      } else if (!this.checkDate()) {
        alert("日期超出范围");
      } else if (this.parmars.billPhone == "") {
        alert("请输入手机号码");
      } else if (!this.checkPhone(this.parmars.billPhone)) {
        alert("请输入正确的手机号码");
      } else if (this.parmars.billMoney == "") {
        alert("请输入开票金额");
      } else if (
        this.parmars.billMoney > parseInt(this.config.maxMoney) ||
        this.parmars.billMoney < parseInt(this.config.minMoney)
      ) {
        alert(
          `发票金额不能输入低于${this.config.minMoney}元高于${this.config.maxMoney}元`
        );
      } else if (
        this.parmars.billCard == "" ||
        this.parmars.billCard.length != 8
      ) {
        alert("请输入身份证后8位");
        this.$refs.identify.refreshCode();
      }
      // else if (this.inpCode != this.identifyCode) {
      //   alert("验证码错误");
      //   this.$refs.identify.refreshCode();
      // }
       else {
        //发票号码校验
        // if (
        //   this.config.billMaxnumber !== "" &&
        //   this.config.billMinnumber !== "" &&
        //   this.config.billNumberflag !== ""
        // ) {
        //   if (this.config.billNumberflag === 0) {
        //     //号段禁止录入
        //     if (
        //       parseInt(this.parmars.billNumber) >=
        //         parseInt(this.config.billMinnumber) &&
        //       parseInt(this.parmars.billNumber) <=
        //         parseInt(this.config.billMaxnumber)
        //     ) {
        //       alert("您的发票不在参与活动范围！");
        //     } else {
        //       this.addInv();
        //     }
        //   } else if (this.config.billNumberflag === 1) {
        //     //仅号段允许录入
        //     if (
        //       parseInt(this.parmars.billNumber) <
        //         parseInt(this.config.billMinnumber) ||
        //       parseInt(this.parmars.billNumber) >
        //         parseInt(this.config.billMaxnumber)
        //     ) {
        //       alert("您的发票不在参与活动范围！");
        //     } else {
        //       this.addInv();
        //     }
        //   }
        // } else {
        //   this.addInv();
        // }
        this.addInv();
      }
    },
    addInv() {
      let data = JSON.parse(JSON.stringify(this.parmars));
      data.billTime = new Date(data.billTime).toISOString();
      sctipts
        .addInvoice(data)
        .then(({ data }) => {
          if (data.status == 0) {
            alert("添加成功");
            this.$refs.identify.refreshCode();
            this.parmars = {
              billCard: "",
              billCode: "",
              billMoney: "",
              billName: "",
              billNumber: "",
              billPhone: "",
              billTime: "",
            };
            // this.inpCode = "";
          } else {
            alert(data.desc);
          }
        })
        .catch(() => {
          alert("系统异常");
        });
    },
    checkDate() {
      // console.log(
      //   `${new Date().getFullYear()}-${
      //     new Date().getMonth() + 1
      //   }-${new Date().getDate()}`
      // );
      let nowTime =
        new Date(
          `${new Date().getFullYear()}-${new Date().getMonth() +
            1}-${new Date().getDate()}`
        ).getTime() + 28800000;
      let inpTime = new Date(this.parmars.billTime).getTime();
      if (
        nowTime - inpTime > 86400000 * parseInt(this.config.maxDay) ||
        nowTime < inpTime
      ) {
        return false;
      } else {
        return true;
      }
    },
    billMoneyChange() {
      this.parmars.billMoney = Math.floor(this.parmars.billMoney * 100) / 100;
    },
    openScan() {
      try {
        let ua = window.navigator.userAgent;
        const isIPhone = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isIPhone) {
          window.webkit.messageHandlers.openScanQrcode.postMessage(
            "openScanQrcode"
          );
        } else {
          window.android.openScanQrcode();
        }
      } catch (error) {
        alert("请使用最新版app打开此页面");
      }
    },
    scanQrcodResult(data) {
      try {
        let arr = data.split(",");
        if (
          arr[1] == "10" ||
          arr[1] == "04" ||
          arr[1] == "01" ||
          arr[1] == "11"
        ) {
          if (arr[2]) {
            this.parmars.billCode = arr[2];
          }
          if (arr[3]) {
            this.parmars.billNumber = arr[3];
          }
          if (arr[4]) {
            this.parmars.billMoney = arr[4];
          }
          if (arr[5]) {
            this.parmars.billTime = `${arr[5].slice(0, 4)}-${arr[5].slice(
              4,
              6
            )}-${arr[5].slice(6, 8)}`;
          }
        } else {
          alert("该发票暂不支持扫码录入");
        }
      } catch (error) {
        alert("该发票暂不支持扫码录入");
      }
    },
  },
  created() {
    window.scanQrcodResult = this.scanQrcodResult;
  },
};
</script>

<style scoped>
.inv-add-inner-box {
  width: 100%;
  min-height: 100%;
  background: url("../assets/img/hbeij.png") no-repeat center top / cover;
  overflow: hidden;
}
.inv-add-content-box {
  width: calc(100% - 0.6rem);
  height: calc(100% - 3.5rem);
  border-radius: 0.1rem;
  margin: 0 auto 0.1rem;
  background-color: #fff;
  overflow: hidden;
}
.inv-add-content-title {
  width: 4rem;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  font-size: 0.32rem;
  color: #fff;
  background: url("../assets/img/biaotiit.png") no-repeat center center / cover;
  margin: 0.3rem auto;
}
.inv-add-content-from {
  width: 100%;
  box-sizing: border-box;
  height: calc(100% - 1.5rem);
  padding: 0 0.6rem;
  margin: 0 auto;
  overflow: auto;
}
.inv-add-content-from > li {
  height: 0.74rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.28rem;
  position: relative;
}
.inv-add-content-from > li > p {
  width: 1.8rem;
  font-size: 0.32rem;
  color: #343434;
  flex-shrink: 0;
  box-sizing: border-box;
}
.inv-add-content-from > li > input {
  width: calc(100% - 1.8rem);
  display: block;
  height: 0.72rem;
  box-sizing: border-box;
  padding-left: 0.2rem;
  border: 1px solid #b2b2b2;
  border-radius: 0.1rem;
  outline: none;
  appearance: none;
  font-size: 0.28rem;
  line-height: 0.72rem;
  color: #666;
  background-color: #fff;
  flex-shrink: 0;
}
.inv-add-content-from > li > img {
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  right: 0.16rem;
  top: 0.16rem;
  background-color: #fff;
}
.inv-add-content-btn {
  width: 4.3rem;
  height: 0.8rem;
  background-color: #549af6;
  color: #ffffff;
  font-size: 0.32rem;
  text-align: center;
  line-height: 0.8rem;
  border-radius: 0.1rem;
  margin: 0.76rem auto 0.3rem;
}
.select-inv {
  color: #999;
  font-size: 0.24rem;
  display: block;
  text-align: center;
  margin-bottom: 0.3rem;
  text-decoration: none;
}
.code-box {
  width: calc(100% - 1.8rem);
  height: 0.72rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.code-box > input {
  display: block;
  height: 0.72rem;
  box-sizing: border-box;
  padding-left: 0.2rem;
  border: 1px solid #b2b2b2;
  border-radius: 0.1rem;
  outline: none;
  appearance: none;
  font-size: 0.28rem;
  line-height: 0.72rem;
  color: #666;
  background-color: #fff;
  flex-shrink: 0;
}
</style>
